module.exports = __webpack_public_path__ + "img/2.1270b741.jpg";